<!--
  黑金 V2 · 提交订单
  目录：views/SelfHelp/blackV2
  业务逻辑复用 BlackCurrentConsume
-->
<template>
  <div class="bv2-current">
    <section class="bv2-dining">
      <div>
        <span>桌号</span>
        <strong>{{ deskCode.code || "未绑定" }}</strong>
      </div>
      <button type="button" @click="openPeoplePopup">
        <span>人数</span>
        <span class="bv2-dining-value">
          <strong>{{ currentPeople }}人</strong>
          <img
            class="bv2-down-arrow"
            src="@/assets/black-micropoint/v2-category-icons/down-arrow.svg"
            alt=""
            aria-hidden="true"
          />
        </span>
      </button>
    </section>

    <section class="bv2-section">
      <header class="bv2-section-title">
        <h2 class="opacity-50">点餐信息</h2>
        <em>按类型</em>
      </header>

      <div v-if="!categoryGroups.length" class="bv2-state">还没有选择菜品</div>
      <article
        v-for="group in categoryGroups"
        v-else
        :key="group.id"
        class="bv2-group"
      >
        <h3>— {{ group.name }} —</h3>
        <div
          v-for="item in group.items"
          :key="getCartItemKey(item)"
          class="bv2-item"
        >
          <img :src="item.image || placeholderImage" :alt="item.name" />
          <div class="bv2-item-main">
            <strong>{{ item.name }}</strong>
            <p v-if="getItemSpecLabel(item)" class="bv2-item-desc">
              {{ getItemSpecLabel(item) }}
            </p>
            <p v-if="item.remarkText" class="bv2-item-remark">
              备注：{{ item.remarkText }}
            </p>
            <p class="bv2-item-price">
              ¥{{ formatMoney(item.price) }}<small>/份</small>
            </p>
          </div>
          <div class="quantity-control">
            <button type="button" @click="changeGoodsQuantity(item, -1)">
              −
            </button>
            <span>{{ item.quantity }}</span>
            <button type="button" @click="changeGoodsQuantity(item, 1)">
              ＋
            </button>
          </div>
        </div>
        <footer>
          <span>{{ group.count }}份餐品 小计：</span>
          <strong>¥{{ formatMoney(group.total) }}</strong>
        </footer>
      </article>

      <div v-if="categoryGroups.length" class="bv2-order-total">
        <span>共{{ totalCount }}份餐品 合计：</span>
        <strong>¥{{ formatMoney(totalMoney) }}</strong>
      </div>
    </section>

    <section class="bv2-section" v-if="payType == 2">
      <header class="bv2-section-title">
        <h2 class="opacity-50">支付方式</h2>
      </header>
      <button type="button" class="bv2-pay-method" @click="openPayPopup">
        <div v-if="vpnInfo.KeyBindComponent === 0" class="bv2-pay-child">
          <span>挂手牌</span>
          <small
            v-if="
              vpnInfo.KeyBindComponent === 0 &&
                (!deskCode.cardCode || deskCode.cardCode.length == 0)
            "
            >微信扫一扫</small
          >
          <small v-else>{{ deskCode.cardCode }}</small>
        </div>
        <div v-if="vpnInfo.KeyBindComponent === 1" class="bv2-pay-child">
          <span>挂手牌</span>
          <small
            v-if="
              vpnInfo.KeyBindComponent === 1 &&
                (!deskCode.cardCode || deskCode.cardCode.length == 0)
            "
            >呼叫服务员</small
          >
          <small v-else>{{ deskCode.cardCode }}</small>
        </div>
        <div v-if="vpnInfo.KeyBindComponent === 2" class="bv2-pay-child">
          <span>挂手牌</span>
          <small
            v-if="
              vpnInfo.KeyBindComponent === 2 &&
                (!deskCode.cardCode || deskCode.cardCode.length == 0)
            "
            >手动输入</small
          >
          <small v-else>{{ deskCode.cardCode }}</small>
        </div>
        <i></i>
      </button>
    </section>

    <section class="bv2-section">
      <header class="bv2-section-title">
        <h2 class="opacity-50">订单备注</h2>
      </header>
      <div class="bv2-remark">
        <textarea
          v-model="orderRemark"
          maxlength="100"
          placeholder="其他需求，可以在此处给商家留言哦"
        ></textarea>
        <span>{{ orderRemark.length }}/100</span>
      </div>
      <div class="bv2-chips">
        <button
          v-for="remark in quickRemarkList"
          :key="remark"
          type="button"
          :class="{ active: selectedRemarks.includes(remark) }"
          @click="toggleQuickRemark(remark)"
        >
          {{ remark }}
        </button>
      </div>
    </section>

    <footer class="bv2-submit-bar">
      <strong class="total-money">¥{{ formatMoney(totalMoney) }}</strong>
      <button type="button" class="bv2-btn ghost" @click="handleContinueOrder">
        继续加菜
      </button>

      <button
        v-if="
          (!deskCode.cardCode || deskCode.cardCode.length <= 0) &&
            vpnInfo.KeyBindComponent === 1 &&
            vpnInfo.WaiterCallPurpose === 1 &&
            payType === 2
        "
        type="button"
        class="bv2-btn gold"
        :disabled="!totalCount || isSubmitting"
        @click="callwaiterSubmit"
      >
        呼叫服务员
      </button>
      <button
        v-else-if="
          payType === 2 ||
            (deskCode.cardCode &&
              deskCode.cardCode.length > 0 &&
              vpnInfo.KeyBindComponent === 1 &&
              vpnInfo.WaiterCallPurpose === 1)
        "
        type="button"
        class="bv2-btn gold"
        :disabled="!totalCount || isSubmitting"
        @click="requestSubmit"
      >
        手牌挂账
      </button>
      <button
        v-else-if="payType === 3"
        type="button"
        class="bv2-btn gold"
        :disabled="!totalCount || isSubmitting"
        @click="requestSubmit"
      >
        餐台挂账
      </button>
      <button
        v-else-if="payType === 1"
        type="button"
        class="bv2-btn gold"
        :disabled="!totalCount || isSubmitting"
        @click="requestSubmit"
      >
        立即支付
      </button>
    </footer>

    <van-popup
      v-model="showPeoplePopup"
      class="bv2-popup"
      position="bottom"
      round
      :get-container="getPopupContainer"
      @closed="resetPeoplePopup"
    >
      <section class="bv2-panel">
        <header>
          <strong>选择用餐人数</strong>
          <button type="button" @click="closePeoplePopup">×</button>
        </header>
        <div class="bv2-people-grid">
          <button
            v-for="number in 12"
            :key="number"
            type="button"
            :class="{ active: pendingPeople === number }"
            @click="pendingPeople = number"
          >
            {{ number }}人
          </button>
        </div>
        <footer>
          <button type="button" class="bv2-btn gold block" @click="confirmPeople">
            确定
          </button>
        </footer>
      </section>
    </van-popup>

    <van-popup
      v-model="showKeyCodePopup"
      class="bv2-popup"
      position="bottom"
      round
      :get-container="getPopupContainer"
      @closed="resetKeyCodePopup"
    >
      <section class="bv2-panel">
        <header>
          <strong>输入手牌号</strong>
          <button type="button" @click="closeKeyCodePopup" class="bv2-close-btn">×</button>
        </header>
        <div class="bv2-keycode">
          <label for="bv2-key-code opacity-50">手牌号</label>
          <input
            class="bv2-key-code-input"
            id="bv2-key-code"
            v-model.trim="pendingCardCode"
            type="text"
            maxlength="30"
            placeholder="请输入手牌号"
          />
        </div>
        <footer class="two">
          <button type="button" class="bv2-btn ghost" @click="closeKeyCodePopup">
            取消
          </button>
          <button type="button" class="bv2-btn gold" @click="confirmKeyCode">
            确定
          </button>
        </footer>
      </section>
    </van-popup>

    <van-popup
      v-model="showSubmitConfirm"
      class="bv2-popup"
      position="bottom"
      round
      :get-container="getPopupContainer"
    >
      <section class="bv2-panel">
        <header>
          <strong>确认提交订单</strong>
          <button type="button" @click="showSubmitConfirm = false">×</button>
        </header>
        <p>
          共 {{ totalCount }} 份餐品，订单金额 ¥{{ formatMoney(totalMoney) }}
        </p>
        <footer class="two">
          <button
            type="button"
            class="bv2-btn ghost"
            @click="showSubmitConfirm = false"
          >
            再看看
          </button>
          <button type="button" class="bv2-btn gold" @click="confirmSubmit">
            确认下单
          </button>
        </footer>
      </section>
    </van-popup>

    <van-popup
      v-model="showUnpaidPopup"
      class="bv2-popup"
      position="bottom"
      round
      :get-container="getPopupContainer"
    >
      <section class="bv2-panel">
        <header><strong>存在未支付订单</strong></header>
        <p>您可以取消未支付订单后提交当前订单，或继续处理上一个订单。</p>
        <footer class="two">
          <button
            type="button"
            class="bv2-btn ghost"
            @click="cancelPreviousOrder"
          >
            取消旧订单
          </button>
          <button type="button" class="bv2-btn gold" @click="handlePreviousOrder">
            继续支付
          </button>
        </footer>
      </section>
    </van-popup>
  </div>
</template>

<script>
import BlackCurrentConsume from "../BlackCurrentConsume.vue";
import {
  getBlackMicropointRouteName,
  getBlackPlaceOrderSuccessRouteName,
  getBlackRecordConsumeRouteName,
} from "@/utils";

export default {
  name: "BlackCurrentConsumeV2",
  extends: BlackCurrentConsume,
  methods: {
    getPopupContainer() {
      return this.$el;
    },
    /** 规格/套餐摘要（不含备注，备注单独展示） */
    getItemSpecLabel(item) {
      const spec = item && item.specName;
      if (!spec || spec === "标准份") return "";
      return spec;
    },
    handlePreviousOrder() {
      this.$router.push({ name: getBlackRecordConsumeRouteName() });
    },
    handleSubmitSuccess(response) {
      if (this.payType == 1) {
        this.$router.replace({
          name: "PayList",
          query: { id: response.OrderId, fromPage: "food" },
        });
      } else {
        this.$router.replace({
          name: getBlackPlaceOrderSuccessRouteName(),
        });
      }
    },
    handleContinueOrder() {
      this.$router.replace({ name: getBlackMicropointRouteName() });
    },
  },
};
</script>

<style lang="scss" scoped>
$bg: #000;
$panel: #1a1a1a;
$gold: #ffc653;
$text: #fff;
$muted: #8f8f8f;
$soft: #cfcfcf;
$btn-text: #20201e;
.opacity-50{
  color: rgba(255, 255, 255, 0.5);
}
.bv2-current {
  min-height: 100vh;
  padding: 28px 24px calc(140px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: $text;
  background: linear-gradient( 180deg, #2D2D2D 0%, #424241 100%);
  color-scheme: dark;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.bv2-dining {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;

  > div,
  > button {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    height: 72px;
    padding: 0 22px;
    border: 1px solid rgba(255, 198, 83, 0.28);
    border-radius: 8px;
    color: $text;
    background: rgba(26, 26, 26, 0.9);
    font-size: 24px;
  }

  strong {
    color: $gold;
    font-size: 26px;
    font-weight: 600;
  }
}

.bv2-dining-value {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.bv2-down-arrow {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.bv2-section {
  margin-bottom: 28px;
}

.bv2-section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  h2 {
    margin: 0;
    color: $gold;
    font-size: 30px;
    font-weight: 600;
    &.opacity-50{
      font-size: 26px;
      color: rgba(255, 255, 255, 0.5);
      font-weight: normal;
    }
  }

  em {
    color: $muted;
    font-size: 22px;
    font-style: normal;
  }
}

.bv2-group {
  margin-bottom: 16px;
  padding: 20px;
  border-radius: 10px;
  background: $panel;

  h3 {
    margin: 0 0 16px;
    color: $gold;
    font-size: 24px;
    text-align: center;
  }

  > footer {
    display: flex;
    justify-content: flex-end;
    padding-top: 14px;
    color: $muted;
    font-size: 22px;

    strong {
      margin-left: 8px;
      color: $gold;
    }
  }
}

.bv2-item {
  display: flex;
  align-items: center;
  padding: 14px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  > img {
    width: 96px;
    height: 96px;
    flex-shrink: 0;
    border-radius: 8px;
    object-fit: cover;
  }
}

.bv2-item-main {
  flex: 1;
  min-width: 0;
  margin: 0 16px;

  strong {
    display: block;
    overflow: hidden;
    font-size: 26px;
    line-height: 36px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.bv2-item-desc {
  margin: 6px 0 0;
  overflow: hidden;
  color: $muted;
  font-size: 20px;
  line-height: 28px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.bv2-item-remark {
  margin: 6px 0 0;
  color: $soft;
  font-size: 22px;
  line-height: 30px;
}

.bv2-item-price {
  margin: 8px 0 0;
  color: $text;
  font-size: 28px;
  font-weight: 500;
  line-height: 40px;

  small {
    margin-left: 2px;
    font-size: 22px;
    font-weight: 400;
  }
}

/* 与 BlackCurrentConsume 一致：圆形金底加减按钮 */
.quantity-control {
  display: flex;
  flex-shrink: 0;
  align-items: center;

  button {
    width: 42px;
    min-width: 42px;
    height: 42px;
    padding: 0;
    border: 0;
    color: #2e240d;
    background: linear-gradient(120deg, #e5c15e, #fff0ba 48%, #e9c769);
    font-size: 26px;
    line-height: 42px;
  }

  span {
    min-width: 40px;
    color: $text;
    font-size: 26px;
    text-align: center;
  }
}

.bv2-order-total {
  display: flex;
  justify-content: flex-end;
  padding: 12px 8px 0;
  color: $soft;
  font-size: 24px;

  strong {
    margin-left: 8px;
    color: $gold;
    font-size: 32px;
  }
}

.bv2-pay-method {
  display: flex;
  width: 100%;
  height: 68px;
  padding: 0 22px;
  align-items: center;
  border: 1px solid rgba(226, 187, 91, 0.22);
  border-radius: 5px;
  box-sizing: border-box;
  color: #f6f2e9;
  background: #1a1a1a;
  font-size: 24px;
  text-align: left;

  small {
    flex: 1;
    margin-left: auto;
    color: #ffffff;
    font-size: 26px;
    text-align: right;
  }

  i {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    margin-left: 18px;
    border: 5px solid #f1c75e;
    border-radius: 50%;
    box-sizing: border-box;
  }
}

.bv2-pay-child {
  display: flex;
  flex: 1;
  align-items: center;
  min-width: 0;
  width: 100%;
}

.bv2-remark {
  position: relative;
  margin-bottom: 16px;

  textarea {
    display: block;
    width: 100%;
    min-height: 160px;
    padding: 20px;
    border: 0;
    border-radius: 10px;
    box-sizing: border-box;
    color: #333333;
    background: $panel;
    font-size: 24px;
    resize: none;
    outline: 0;
    background: rgba(255,255,255,0.5);
    &::placeholder {
      color: #333;
    }
  }

  span {
    position: absolute;
    right: 16px;
    bottom: 12px;
    color: $muted;
    font-size: 20px;
  }
}

.bv2-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  button {
    min-height: 56px;
    padding: 0 20px;
    border: 0;
    border-radius: 8px;
    color: $text;
    background: #2b2b2b;
    font-size: 22px;

    &.active {
      color: $btn-text;
      background: linear-gradient(120deg, #e5c15e, #fff0ba 48%, #e9c769);
    }
  }
}

.bv2-state {
  padding: 60px 20px;
  color: $muted;
  text-align: center;
  font-size: 26px;
}

.bv2-submit-bar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 24px calc(16px + env(safe-area-inset-bottom));
  background: #20201e;
  border-top: 1px solid rgba(255, 198, 83, 0.35);
  box-sizing: border-box;

  > strong {
    flex: 1;
    color: $gold;
    font-size: 36px;
    &.total-money{
      font-size: 48px;
    }
  }
}

.bv2-btn {
  height: 82px;
  padding: 0 24px;
  border: 0;
  border-radius: 10px;
  font-size: 32px;
  font-weight: 500;

  &.ghost {
    color: $text;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.35);
  }

  &.gold {
    color: $btn-text;
    background: linear-gradient(120deg, #e5c15e, #fff0ba 48%, #e9c769);
  }

  &.block {
    width: 100%;
  }

  &:disabled {
    opacity: 0.55;
  }
}

.bv2-popup {
  background: linear-gradient( 180deg, #3B3A3A 0%, #222120 100%);
  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.25);
}

.bv2-panel {
  padding-bottom: env(safe-area-inset-bottom);
  color: $text;
  background: linear-gradient( 180deg, #3B3A3A 0%, #222120 100%);
  box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.25);

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 28px 24px 18px;
    margin-bottom: 40px;

    strong {
      font-size: 32px;
    }

    button {
      border: 0;
      color: $text;
      background: transparent;
      font-size: 40px;
      line-height: 1;
    }
    .bv2-close-btn{
      font-size: 60px !important;
    }
  
  }
  .bv2-key-code-input{
     color: #333333;
      background:rgba(255, 255, 255, 0.5);
      &::placeholder {
        color: #333;
      }
    }
  > p {
    padding: 0 24px 20px;
    color: $soft;
    font-size: 26px;
    line-height: 38px;
  }

  footer {
    display: flex;
    gap: 16px;
    padding: 16px 24px calc(16px + env(safe-area-inset-bottom));

    &.two .bv2-btn {
      flex: 1;
    }
  }
}

.bv2-people-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  padding: 0 24px 20px;

  button {
    height: 72px;
    border: 0;
    border-radius: 8px;
    color: $text;
    background: #2b2b2b;
    font-size: 26px;

    &.active {
      color: $btn-text;
      background: linear-gradient(120deg, #e5c15e, #fff0ba 48%, #e9c769);;
    }
  }
}

.bv2-keycode {
  padding: 0 24px 20px;
  margin-bottom: 40px;

  label {
    display: block;
    margin-bottom: 12px;
    font-size: 24px;
    color: rgba(255, 255, 255, 0.5);
  }

  input {
    width: 100%;
    height: 80px;
    padding: 0 20px;
    border: 0;
    border-radius: 8px;
    box-sizing: border-box;
    color: $text;
    background: #2f2f2f;
    font-size: 28px;
    outline: 0;
  }
}
</style>
